export default __webpack_public_path__ + "static/media/iconSnackbar_cashback.f5acd322.svg";